<div class="sbc-loader-container">
  <sbc-loader *ngIf="isLoadingDirectoryData"></sbc-loader>
</div>

<div #widget class="exhibitors-directory-element" *ngIf="!isLoadingDirectoryData"
  [style.--primary]="primarycolor || eventColors.primaryBg">

  <div class="ed-filters">
    <div class="ed-filters__main">
      <div>
        <input [(ngModel)]="searchPhrase" #search (input)="onFilterApplied(QueryParams.Search, search.value)"
          class="search-control" [placeholder]="('search' | translate) + '...'" />
      </div>
      <ng-select class="category-select" [(ngModel)]="selectedCategoryId" (change)="onCategorySelect($event)" [placeholder]="'select_category' | translate"
        [searchable]="false">
        <ng-option *ngFor="let cat of categories" [value]="cat.categoryId">{{cat.categoryName | translate}}</ng-option>
      </ng-select>
    </div>
    <div *ngIf="zones" class="zone-select-wrapper">
      <ng-select [(ngModel)]="selectedZones" (change)="onZoneSelect($event)" [placeholder]="'select_zone' | translate"
        [searchable]="false" [items]="zones" [multiple]="true" bindLabel="zoneName" bindValue="zoneId"
        [closeOnSelect]="false">
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
          <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected" /> {{item.zoneName}}
        </ng-template>
      </ng-select>
    </div>
    <sbc-alphabet-filter *ngIf="alphabet === 'on'" [(ngModel)]="selectedCharacter"
      (ngModelChange)="onFilterApplied(QueryParams.Character, $event)"
      [exhibitors]="exhibitors | filters: categoryFilter : zoneFilter : searchFilter"></sbc-alphabet-filter>
  </div>

  <div class="ed-body">
    <ng-container *ngIf="!selectedEntry">
      <sbc-exhibitor-entry
        *ngFor="let exh of exhibitors | filters: categoryFilter : zoneFilter : searchFilter : characterFilter : pageFilter; trackBy: trackByFn"
        [exhibitor]="exh" (onExhibitorSelected)="onExhibitorSelected($event)"
        (onCategorySelected)="selectCategory($event)"></sbc-exhibitor-entry>

      <ng-container *ngIf="hasMoreEntriesThanVisible">
        <div class="show-more-btn btn" (click)="incrementShownExhibitorsCount()">
          {{ 'show_more' | translate }}
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="selectedEntry">
      <div class="exhibitors-nav">
        <div (click)="goBack()">
          <img [src]="'/assets/icons/caret.svg' | azureasset" alt="caret" />
          <span>{{ 'go_back' | translate }}</span>
        </div>
        <div class="flex"></div>
        <div *ngIf="queriedExhibitors.length > 1" (click)="displayPrevious()">
          <img [src]="'/assets/icons/caret.svg' | azureasset" alt="caret" />
          <span>{{ 'previous' | translate }}</span>
        </div>
        <div *ngIf="queriedExhibitors.length > 1" (click)="displayNext()">
          <span>{{ 'next' | translate }}</span>
          <img [src]="'/assets/icons/caret.svg' | azureasset" alt="caret" />
        </div>
      </div>
      <sbc-extended-exhibitor-entry [exhibitor]="selectedEntry" [relatedExhibitors]="relatedExhibitors"
        (onCategorySelected)="selectCategory($event)" (onExhibitorSelected)="onExhibitorSelected($event)">
      </sbc-extended-exhibitor-entry>
    </ng-container>
  </div>
</div>
